import { useState, FC } from "react";
import { tools, tabs } from "../data/tools";

import { useNavigate } from "react-router-dom";

const BRAND = "#2563eb";

interface ToolCardProps {
  tool: typeof tools[0];
  onClick?: () => void;
}

const ToolCard: FC<ToolCardProps> = ({ tool, onClick }) => {
  const [hovered, setHovered] = useState<boolean>(false);


  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "#fff",
        border: `1px solid ${hovered && tool.name === "JPG to PDF" ? BRAND : "#f0ede8"}`,
        borderRadius: 14,
        padding: "20px 18px",
        cursor: tool.name === "JPG to PDF" ? "pointer" : "default",
        transition: "all 0.18s",
        transform: hovered && tool.name === "JPG to PDF" ? "translateY(-3px)" : "none",
        boxShadow: hovered && tool.name === "JPG to PDF" ? "0 8px 24px rgba(37,99,235,0.12)" : "none",
      }}
    >
      <div style={{
        width: 44, height: 44, borderRadius: 10,
        background: tool.bg,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 12, fontSize: 22,
      }}>
        {tool.icon}
      </div>
      <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 5, color: "#1a1a1a" }}>{tool.name}</h3>
      <p style={{ fontSize: 12, color: "#888", lineHeight: 1.5 }}>{tool.desc}</p>
    </div>
  );
};

interface ToolsSectionProps {
  onJPGToPDFClick?: () => void;
}

const ToolsSection: FC<ToolsSectionProps> = ( ) => {
  const [activeTab, setActiveTab] = useState<string>("All");
    const navigate = useNavigate();

  const filtered = activeTab === "All" ? tools : tools.filter((t) => t.category === activeTab);

  return (
    <div style={{ padding: "52px 40px" }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 6 }}>Most popular PDF tools</h2>
      <p style={{ fontSize: 15, color: "#888", marginBottom: 28 }}>
        10+ tools to convert, compress, and edit PDFs for free.
      </p>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 28, flexWrap: "wrap" }}>
        {tabs.map((tab) => (
          <button key={tab} onClick={() => setActiveTab(tab)}
            style={{
              fontSize: 13, padding: "7px 16px", borderRadius: 99, border: "1px solid",
              cursor: "pointer", transition: "all 0.15s", fontWeight: activeTab === tab ? 600 : 400,
              background: activeTab === tab ? BRAND : "transparent",
              color: activeTab === tab ? "#fff" : "#666",
              borderColor: activeTab === tab ? BRAND : "#ddd",
            }}>
            {tab}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
        gap: 14,
      }}>
        {filtered.map((tool) => (
          <ToolCard key={tool.id} tool={tool} onClick={() =>  navigate(tool.url)} />
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: 32 }}>
        <button style={{
          fontSize: 14, padding: "10px 24px", border: `1px solid ${BRAND}`,
          borderRadius: 8, cursor: "pointer", background: "transparent",
          color: BRAND, fontWeight: 500, transition: "all 0.15s",
        }}
          onMouseEnter={(e) => { e.currentTarget.style.background = BRAND; e.currentTarget.style.color = "#fff"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = BRAND; }}>
          See all PDF tools →
        </button>
      </div>
    </div>
  );
};

export default ToolsSection;

